import routes from "@/routes";
import { lazy } from "react";

const CompanyBeta = lazy(() => import("@/modules/VisitorInsight/CompanyBeta"));

/**
 * Sibling of `companyInsight.routes.tsx`, gated on the same
 * `COMPANY_VISITOR_INSIGHTS` permission.
 */
const CompanyInsightBetaRoutes = {
  element: <CompanyBeta />,
  path: routes.VISITOR_INSIGHTS.COMPANY_BETA.INDEX,
};

export default CompanyInsightBetaRoutes;
